<template>
  <div>
    <TopBar :page="topBarData"/>

    <v-container fluid>

      <v-row>
        <v-col>
          <CplListTable />
        </v-col>
      </v-row>

    </v-container>

  </div>
</template>

<script>

  import { mapActions } from 'vuex';

  import TopBar from '@/components/Layout/TopBar';
  import CplListTable from '@/components/Marketing/CplListTable';

  export default {
    components: { TopBar,CplListTable },
    
    data() {
      return {}
    },

    created () {
      this.fetchCplLeads();
      this.fetchStatuses();
      this.fetchSources();
    },

    computed: {

      topBarData() {
        return {
          name: 'CPL Dashboard',
          type: 'cpl',
          menu: false,
          showSearch: true,
          breadcrumbs: []
        }
      },

    },

    methods: {
      ...mapActions('cpl',['fetchCplLeads','fetchStatuses','fetchSources']),
    },
  }
</script>

<style lang="scss" scoped></style>
